export const loc = [
  {
    id: 0,
    title: "Punjab",

    key: "location",
    children: [
      {
        id: 2,
        title: "Lahore",

        key: "location",
        children: [
          {
            id: 2,
            title: "Allama Iqbal Town",

            key: "location",
          },
          {
            id: 3,
            title: "Faisal Town",

            key: "location",
          },
          {
            id: 4,
            title: "Samanabad",

            key: "location",
          },
          {
            id: 5,
            title: "Gulshan E Ravi",

            key: "location",
          },
          {
            id: 6,
            title: "Awan Town",

            key: "location",
          },
          {
            id: 3,
            title: "	Ichhra",

            key: "location",
          },
        ],
      },
      {
        id: 2,
        title: "Multan",

        key: "location",
      },
      {
        id: 3,
        title: "Rawalpindi",

        key: "location",
        children: [
          {
            id: 2,
            title: "Allama Iqbal Town",

            key: "location",
          },
          {
            id: 3,
            title: "Faisal Town",

            key: "location",
          },
          {
            id: 4,
            title: "Samanabad",

            key: "location",
          },
          {
            id: 5,
            title: "Gulshan E Ravi",

            key: "location",
          },
          {
            id: 6,
            title: "Awan Town",

            key: "location",
          },
          {
            id: 3,
            title: "	Ichhra",

            key: "location",
          },
        ],
      },
      {
        id: 4,
        title: "Gujranwala",

        key: "location",
      },
      {
        id: 5,
        title: "Sialkot",

        key: "location",
        children: [
          {
            id: 2,
            title: "Allama Iqbal Town",

            key: "location",
          },
          {
            id: 3,
            title: "Faisal Town",

            key: "location",
          },
          {
            id: 4,
            title: "Samanabad",

            key: "location",
          },
          {
            id: 5,
            title: "Gulshan E Ravi",

            key: "location",
          },
          {
            id: 6,
            title: "Awan Town",

            key: "location",
          },
          {
            id: 3,
            title: "	Ichhra",

            key: "location",
          },
        ],
      },
    ],
  },
  {
    id: 1,
    title: "Sindh",

    key: "location",
  },
  {
    id: 2,
    title: "Blochistan",

    key: "location",
  },
  {
    id: 3,
    title: "KPK",

    key: "location",
    children: [
      {
        id: 2,
        title: "Lahore",

        key: "location",
        children: [
          {
            id: 2,
            title: "Allama Iqbal Town",

            key: "location",
          },
          {
            id: 3,
            title: "Faisal Town",

            key: "location",
          },
          {
            id: 4,
            title: "Samanabad",

            key: "location",
          },
          {
            id: 5,
            title: "Gulshan E Ravi",

            key: "location",
          },
          {
            id: 6,
            title: "Awan Town",

            key: "location",
          },
          {
            id: 3,
            title: "	Ichhra",

            key: "location",
          },
        ],
      },
      {
        id: 2,
        title: "Multan",

        key: "location",
      },
      {
        id: 3,
        title: "Rawalpindi",

        key: "location",
        children: [
          {
            id: 2,
            title: "Allama Iqbal Town",

            key: "location",
          },
          {
            id: 3,
            title: "Faisal Town",

            key: "location",
          },
          {
            id: 4,
            title: "Samanabad",

            key: "location",
          },
          {
            id: 5,
            title: "Gulshan E Ravi",

            key: "location",
          },
          {
            id: 6,
            title: "Awan Town",

            key: "location",
          },
          {
            id: 3,
            title: "	Ichhra",

            key: "location",
          },
        ],
      },
      {
        id: 4,
        title: "Gujranwala",

        key: "location",
      },
      {
        id: 5,
        title: "Sialkot",

        key: "location",
        children: [
          {
            id: 2,
            title: "Allama Iqbal Town",

            key: "location",
          },
          {
            id: 3,
            title: "Faisal Town",

            key: "location",
          },
          {
            id: 4,
            title: "Samanabad",

            key: "location",
          },
          {
            id: 5,
            title: "Gulshan E Ravi",

            key: "location",
          },
          {
            id: 6,
            title: "Awan Town",

            key: "location",
          },
          {
            id: 3,
            title: "Ichhra",

            key: "location",
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Common/DropDown/sampleData.js